var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBehance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3239_22342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6875 11.8125C10.6875 11.8125 11.8125 11.3944 11.8125 9.9375C11.8125 8.48063 10.8488 7.875 9.5625 7.875H5.25V16.125H9.5625C9.5625 16.125 12 16.125 12 13.6875C12 13.6875 12 11.8125 10.6875 11.8125ZM7.125 9.375H9.5625C9.5625 9.375 10.125 9.375 10.125 10.125C10.125 10.9725 9.75 11.0625 9.375 11.0625H7.125V9.375ZM9.375 14.625H7.125V12.5625L9.48563 12.5494C9.48563 12.5494 10.3125 12.5625 10.3125 13.6875C10.3125 14.625 9.71438 14.6156 9.375 14.625ZM15.8944 9.915C12.765 9.915 12.7669 13.0425 12.7669 13.0425C12.7669 13.0425 12.5944 16.125 15.9375 16.125C15.9375 16.125 18.75 16.3856 18.75 14.0625H17.25C17.25 14.0625 17.295 14.865 15.9375 14.865C15.9375 14.865 14.4375 15.0131 14.4375 13.5H18.75C18.75 13.5 19.1887 9.915 15.8944 9.915ZM17.25 12.375H14.4375C14.4375 12.375 14.67 11.1075 15.9263 11.1075C17.1825 11.1075 17.25 12.375 17.25 12.375ZM14.0625 8.25H17.625V9.375H14.0625V8.25Z",
    fill: "#111111"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3239_22342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehance);
export default __webpack_public_path__ + "static/media/behance.5fc6954799806b3b45d5afd5b8554ed5.svg";
export { ForwardRef as ReactComponent };